import { VideoPresets } from "livekit-client";

/**
 * LiveKit Room connection options: {@link RoomOptions}
 * or {@link https://docs.livekit.io/client-sdk-js/interfaces/RoomOptions.html}
 */
export default function useRoomOptions() {
  return {
    // Remote audio plays through one always-running Web Audio graph instead of
    // per-track <audio> elements: iPadOS parks an element whose track goes
    // silent between OKO phrases and loses the first seconds waking it up.
    webAudioMix: true,
    publishDefaults: {
      videoEncoding: {
        ...VideoPresets.h360.encoding,
        frameRate: 20
      }
    }
  };
};
